import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "22",
  height: "22",
  fill: "none",
  viewBox: "0 0 22 22"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#F0EEEC",
      d: "M22 11c0 6.075-4.925 11-11 11S0 17.075 0 11 4.925 0 11 0s11 4.925 11 11ZM3.43 11a7.57 7.57 0 1 0 15.14 0 7.57 7.57 0 0 0-15.14 0Z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M20.285 11c.947 0 1.729-.772 1.582-1.708A11.003 11.003 0 0 0 12.708.133C11.772-.014 11 .768 11 1.715c0 .947.777 1.696 1.7 1.908A7.57 7.57 0 0 1 18.377 9.3c.212.923.96 1.7 1.908 1.7Z"
    }, null, -1),
    _createElementVNode("animateTransform", {
      attributeName: "transform",
      type: "rotate",
      from: "0 0 0",
      to: "360 0 0",
      dur: "1000ms",
      repeatCount: "indefinite"
    }, null, -1)
  ])))
}
export default { render: render }